import React from 'react';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';
import { FormattedMessage } from 'gatsby-plugin-intl';

import Text from '@components/text';
import { Link } from 'gatsby';
import ArrowDefault from '@images/arrow.svg';

const Wrapper = tw.div`flex justify-center items-center w-320 mt-20 mx-auto lg:mt-0 lg:mb-10`;

const Item = styled(Link)`
  ${tw`relative flex items-center mx-15 px-12 pb-8`}

  ::after {
    content: '';
    ${tw`absolute inset-x-0 bottom-0 h-1 bg-greyBlog`}
  }
`;

const Arrow = styled(ArrowDefault)`
  width: 23px;
  transform: scaleX(${({ left }) => (left ? -1 : 1)});
  ${({ left }) => (left ? tw`mr-8` : tw`ml-8`)}
`;

const Nav = ({ nextPage, prevPage, locale }) => {
  const pathTo = (path) => {
    const fullPath = `${locale === 'en' ? '/en' : ''}${path}`;
    return fullPath.endsWith('/') ? fullPath : `${fullPath}/`;
  };

  return (
    <Wrapper>
      {prevPage && (
        <Item to={pathTo(prevPage)}>
          <Arrow left />
          <Text fontSizes={18} lineHeight={1.3} letterSpacing={22}>
            <FormattedMessage id="blog.prev page" />
          </Text>
        </Item>
      )}
      {nextPage && (
        <Item to={pathTo(nextPage)}>
          <Text fontSizes={18} lineHeight={1.3} letterSpacing={22}>
            <FormattedMessage id="blog.next page" />
          </Text>
          <Arrow />
        </Item>
      )}
    </Wrapper>
  );
};

Nav.propTypes = {
  nextPage: PropTypes.string.isRequired,
  prevPage: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
};

export default Nav;
